<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" d="M9 4h2.41v2.15H9zm.13 12.51V7.97h2.18v8.54z"/></svg>